import type {
  Argon2idWorkerClient,
  Argon2idWorkerFactory,
  Argon2idWorkerRequest,
  Argon2idWorkerResponse,
} from './argon2id-worker.protocol';

class BrowserArgon2idWorkerClient implements Argon2idWorkerClient {
  constructor(private readonly worker: Worker) {}

  onMessage(listener: (response: Argon2idWorkerResponse) => void): void {
    this.worker.addEventListener('message', (event) => listener(event.data));
  }

  onError(listener: () => void): void {
    this.worker.addEventListener('error', () => listener());
  }

  post(request: Argon2idWorkerRequest): void {
    this.worker.postMessage(request);
  }

  terminate(): void {
    this.worker.terminate();
  }
}

export const createBrowserArgon2idWorker: Argon2idWorkerFactory = () =>
  new BrowserArgon2idWorkerClient(
    new Worker(new URL('./argon2id.worker', import.meta.url), { type: 'module' }),
  );
